"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.columnsAdd = columnsAdd;
exports.serializeColumns = void 0;
var _react = _interopRequireDefault(require("react"));
var _concat2 = _interopRequireDefault(require("lodash/concat"));
var _tag = _interopRequireDefault(require("./components/tag"));
var _datatableModule = _interopRequireDefault(require("./datatable.module.scss"));
var _date = _interopRequireDefault(require("./components/date"));
var _link = _interopRequireDefault(require("./components/link"));
var _type = _interopRequireDefault(require("./components/type"));
var _status = _interopRequireDefault(require("./components/status"));
var _workflow = _interopRequireDefault(require("./components/workflow"));
var _owner = _interopRequireDefault(require("./components/owner"));
var _profile = _interopRequireDefault(require("./components/profile"));
var _orderstatus = _interopRequireDefault(require("./components/orderstatus"));
var _ordersummary = _interopRequireDefault(require("./components/ordersummary"));
var _bool = _interopRequireDefault(require("./components/bool"));
var _stock = _interopRequireDefault(require("./components/stock"));
var _searchterm = _interopRequireDefault(require("./components/searchterm"));
var _object = _interopRequireDefault(require("./components/object"));
var _synonyms = _interopRequireDefault(require("./components/synonyms"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var serializeColumns = function serializeColumns(columns, onRowAction) {
  //columns = [{},{},{}]
  columns.map(function (column) {
    if ((column === null || column === void 0 ? void 0 : column.key) !== 'skuListSort') {
      column.dataIndex = column === null || column === void 0 ? void 0 : column.id;
      column.key = column === null || column === void 0 ? void 0 : column.id;
      column.ellipsis = true;
      column.sorter = false;
      column.width = (column === null || column === void 0 ? void 0 : column.width) || 200;
      if (column !== null && column !== void 0 && column.fixed) {
        var fixed = column === null || column === void 0 ? void 0 : column.fixed;
        column.fixed = fixed;
      }
      column.render = function (data, row, dataIndex) {
        var dataType = /*#__PURE__*/_react["default"].createElement("span", {
          className: _datatableModule["default"].text
        }, data);
        if (column !== null && column !== void 0 && column.isArray) {
          var name = column === null || column === void 0 ? void 0 : column.name;
          var dataLocal = row;
          for (var item in name) {
            if (dataLocal[name[item]]) {
              dataLocal = dataLocal[name[item]];
            }
          }
          if (typeof dataLocal === 'string') {
            dataType = /*#__PURE__*/_react["default"].createElement("span", {
              className: _datatableModule["default"].text
            }, dataLocal);
          } else if (typeof dataLocal === 'boolean') {
            data = dataLocal;
          }
        }
        if (column.widget === 'link') {
          dataType = /*#__PURE__*/_react["default"].createElement(_link["default"], {
            data: data,
            row: row,
            onRowAction: onRowAction,
            applyLinkstyles: column === null || column === void 0 ? void 0 : column.applyLinkstyles,
            column: column
          });
        } else if (column.widget === 'tag') {
          dataType = /*#__PURE__*/_react["default"].createElement(_tag["default"], {
            data: data,
            row: row
          });
        } else if (column.widget === 'date') {
          dataType = /*#__PURE__*/_react["default"].createElement(_date["default"], {
            data: data,
            row: row
          });
        } else if (column.widget === 'workflow') {
          dataType = /*#__PURE__*/_react["default"].createElement(_workflow["default"], {
            data: data,
            row: row
          });
        } else if (column.widget === 'nameworkflow') {
          dataType = /*#__PURE__*/_react["default"].createElement(_workflow["default"], {
            data: data,
            row: row
          });
        } else if (column.widget === 'owner') {
          dataType = /*#__PURE__*/_react["default"].createElement(_owner["default"], {
            data: data,
            row: row
          });
        } else if (column.widget === 'searchTerm') {
          dataType = /*#__PURE__*/_react["default"].createElement(_searchterm["default"], {
            onRowAction: onRowAction,
            keyName: column === null || column === void 0 ? void 0 : column.keyName,
            data: data,
            row: row
          });
        } else if (column.widget === 'object') {
          dataType = /*#__PURE__*/_react["default"].createElement(_object["default"], {
            keyName: column === null || column === void 0 ? void 0 : column.keyName,
            data: data,
            row: row
          });
        } else if (column.widget === 'synonyms') {
          dataType = /*#__PURE__*/_react["default"].createElement(_synonyms["default"], {
            keyName: column === null || column === void 0 ? void 0 : column.keyName,
            data: data,
            row: row
          });
        } else if (column.widget === 'status') {
          dataType = /*#__PURE__*/_react["default"].createElement(_status["default"], {
            custom: column !== null && column !== void 0 && column.custom ? column === null || column === void 0 ? void 0 : column.custom : 'default',
            data: data,
            row: row
          });
        } else if (column.widget === 'type') {
          dataType = /*#__PURE__*/_react["default"].createElement(_type["default"], {
            data: data,
            row: row
          });
        } else if (column.widget === 'profile') {
          dataType = /*#__PURE__*/_react["default"].createElement(_profile["default"], {
            data: data,
            row: row
          });
        } else if (column.widget === 'orderstatus') {
          dataType = /*#__PURE__*/_react["default"].createElement(_orderstatus["default"], {
            data: data,
            row: row
          });
        } else if (column.widget === 'ordersummary') {
          dataType = /*#__PURE__*/_react["default"].createElement(_ordersummary["default"], {
            data: data,
            row: row
          });
        } else if (column.widget === 'bool') {
          dataType = /*#__PURE__*/_react["default"].createElement(_bool["default"], {
            data: data,
            noKey: column === null || column === void 0 ? void 0 : column.noKey,
            yesKey: column === null || column === void 0 ? void 0 : column.yesKey,
            row: row
          });
        } else if (column.widget === 'stock') {
          dataType = /*#__PURE__*/_react["default"].createElement(_stock["default"], {
            data: data,
            row: row
          });
        }
        return dataType;
      };
    }
    return column;
  });
  return columns;
};
exports.serializeColumns = serializeColumns;
function columnsAdd(allcolumns, columnList) {
  columnList = columnList.map(function (colObject, index) {
    return colObject;
  });
  return (0, _concat2["default"])(allcolumns, columnList);
}